<div class="dialog-title">New UOM</div>

<mat-form-field>
  <input matInput placeholder="Code" />
</mat-form-field>

<mat-form-field>
  <input matInput placeholder="Name" />
</mat-form-field>

<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" [mat-dialog-close]="false">Save</button>
</div>
